import he from 'he'
import { getTips as getTipsAPI } from '../api/tips'
import { setTips } from '../state/slices/tips_slice'
import { useAppDispatch } from './state'
export const useTips = () => {
  const dispatch = useAppDispatch()

  const getTips = async () => {
    try {
      const result = await getTipsAPI()

      if (result.data) {
        result.data.preventionTips = result.data.preventionTips.map((tip) => ({
          ...tip,
          subject: he.decode(tip.subject)
        }))

        dispatch(setTips(result.data.preventionTips))
      }

      return true
    } catch (error) {
      return false
    }
  }

  return {
    getTips
  }
}

export default useTips
